

export const base64Encode = (str: string) => {
  var c1, c2, c3;
  var base64EncodeChars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
  var i = 0, len = str.length, strin = '';
  while (i < len) {
      c1 = str.charCodeAt(i++) & 0xff;
      if (i === len) {
          strin += base64EncodeChars.charAt(c1 >> 2);
          strin += base64EncodeChars.charAt((c1 & 0x3) << 4);
          strin += "==";
          break;
      }
      c2 = str.charCodeAt(i++);
      if (i === len) {
          strin += base64EncodeChars.charAt(c1 >> 2);
          strin += base64EncodeChars.charAt(((c1 & 0x3) << 4) | ((c2 & 0xF0) >> 4));
          strin += base64EncodeChars.charAt((c2 & 0xF) << 2);
          strin += "=";
          break;
      }
      c3 = str.charCodeAt(i++);
      strin += base64EncodeChars.charAt(c1 >> 2);
      strin += base64EncodeChars.charAt(((c1 & 0x3) << 4) | ((c2 & 0xF0) >> 4));
      strin += base64EncodeChars.charAt(((c2 & 0xF) << 2) | ((c3 & 0xC0) >> 6));
      strin += base64EncodeChars.charAt(c3 & 0x3F)
  }
  return strin
} 


export const getFileExtension = (filename: string) => {
    // 确保传入的文件名是一个字符串
    if (typeof filename !== 'string') {
        throw new Error('Filename must be a string');
    }

    // 获取最后一个 . 的位置
    const lastDotIndex = filename.lastIndexOf('.');

    // 如果没有找到 . 或者 . 出现在第一个位置，则认为没有扩展名
    if (lastDotIndex === -1 || lastDotIndex === 0) {
        return '';
    }

    // 提取并返回扩展名
    return filename.slice(lastDotIndex + 1);
}

export const uuidGenerate = () => {
  return 'xxxxxxxxxxxxxxxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function(c) { 
   var r = Math.random() * 16 | 0, v = c === 'x' ? r : (r && 0x3 | 0x8);
   return v.toString(16);
 })
}

export function generateRandomString(length: number): string {
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let result = '';
  
  for (let i = 0; i < length; i++) {
    const randomIndex = Math.floor(Math.random() * characters.length);
    result += characters[randomIndex];
  }

  return result;
}

export const handleUrlDownload = async (currentUrl: string | null) => {
  if (!currentUrl) {
    console.error('Download URL is not provided.');
    return;
  }
  const headers = {
    'Referer': 'http://liehuzuoai.com'
  };

  const response = await fetch(currentUrl, { headers });
  if (!response.ok) {
    throw new Error(`下载失败: ${response.status}`);
  }

  const blob = await response.blob();
  const blobUrl = URL.createObjectURL(blob);

  const link = document.createElement('a');
  link.href = blobUrl;
  const filename = currentUrl.split('/').pop() || 'video.mp4';
  link.setAttribute('download', filename);

  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);

  URL.revokeObjectURL(blobUrl);
};


export const sqlInjectionPattern = /('|"|;|--|\/\*|\*\/|@@|@|&&|union\s+select|drop\s+table)/i;

